$("#contact-form").validate();
window.recapDone = () => {
  document.getElementById("submitBtn").disabled=false;
}
window.recapExpired = () => {
  document.getElementById("submitBtn").disabled=true;
}
